import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

import { useInventoryCategories } from '@hooks';
import { L } from '@lib';

interface IProps {
  disabled?: boolean;
  value?: string;
  width?: string;
  size?: 'large' | 'middle' | 'small';
  onChange?: ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const ServiceExtraTypeSelect: React.FC<IProps> = observer(
  ({ disabled = false, value, width = '100%', size, onChange }) => {
    const { categories } = useInventoryCategories();

    const options = useMemo(() => {
      const opts = categories.map((c) => ({ label: c.name, value: c.name }));
      // Preserve any legacy value that isn't in the category list so existing records still display their Type.
      if (value && !opts.some((o) => o.value === value)) {
        opts.unshift({ label: value, value });
      }
      return opts;
    }, [categories, value]);

    return (
      <Select
        disabled={disabled}
        placeholder={L('Type')}
        style={{ width }}
        size={size}
        value={value || undefined}
        options={options}
        onChange={onChange}
        popupMatchSelectWidth={false}
        getPopupContainer={(trigger) => trigger.parentElement || document.body}
      />
    );
  }
);
